module.exports = __webpack_public_path__ + "static/media/plus.e438c2be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/plus.svg
// module id = 28
// module chunks = 0